import { MEMBER_OPTIONS } from 'components/shared/Filters/lib/filterOptions';

export default {
  nameSearchTerm: {
    title: 'Name',
    placeholder: 'Search by name',
    allowed_operators: ['contains', 'does not contain'],
    icon: 'first-line-mono'
  },
  created_by: {
    ...MEMBER_OPTIONS,
    title: 'Created By',
    allowed_operators: ['is', 'is not', 'is any of']
  }
};
